var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/Geolocation/Geolocation", "jquery"], function (require, exports, Geolocation) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initializeButton = exports.place = void 0;
    Geolocation = __importStar(Geolocation);
    function googleMapsPlace(strasse, plz, ort) {
        var slash = strasse.indexOf("/");
        if (slash !== -1) {
            strasse = strasse.slice(0, slash);
        }
        slash = strasse.indexOf("(");
        if (slash !== -1) {
            strasse = strasse.slice(0, slash);
        }
        slash = ort.indexOf("/");
        if (slash !== -1) {
            ort = ort.slice(0, slash);
        }
        return "".concat(strasse, ",").concat(plz, " ").concat(ort);
    }
    function place(strasse, plz, ort) {
        var googleMapsUrl = "https://www.google.com/maps/search/" + googleMapsPlace(strasse, plz, ort) + "+drklein";
        return googleMapsUrl.replace(/ /g, "+");
    }
    exports.place = place;
    function createGoogleMapsUrl(whereAmI, strasse, plz, ort) {
        var googleMapsUrl = "https://www.google.com/maps/dir//".concat(googleMapsPlace(strasse, plz, ort), "+drklein");
        return googleMapsUrl.replace(/ /g, "+");
    }
    function initializeButton($routeBerechnenButton) {
        Geolocation.getGeolocation()
            .then(function (location) {
            if (location !== null) {
                var here = "".concat(location.latitude, ",").concat(location.longitude);
                var strasse = $routeBerechnenButton.data("strasse");
                var plz = $routeBerechnenButton.data("plz");
                var ort = $routeBerechnenButton.data("ort");
                $routeBerechnenButton.attr("href", createGoogleMapsUrl(here, strasse, plz, ort));
            }
        });
    }
    exports.initializeButton = initializeButton;
    if ($(".googleMapsButton").length) {
        $(".googleMapsButton").each(function (index, element) { return initializeButton($(element)); });
    }
});
